import { rbAxios } from "@/main";
import Vue from "vue";

// Function to draw image with "object-fit: cover" behavior
export function drawImageOnCanvasCover(canvas, img, width, height) {
  const ctx = canvas.getContext("2d");
  canvas.width = width;
  canvas.height = height;

  // Calculate the scaling factor to cover the canvas
  const scale = Math.max(width / img.width, height / img.height);

  // Calculate the new dimensions of the image
  const newWidth = img.width * scale;
  const newHeight = img.height * scale;

  // Calculate the position to center the image on the canvas
  const offsetX = (width - newWidth) / 2;
  const offsetY = (height - newHeight) / 2;

  ctx.imageSmoothingEnabled = true;
  ctx.imageSmoothingQuality = "high";

  // Draw the image on the canvas
  ctx.drawImage(img, offsetX, offsetY, newWidth, newHeight);
}

export function base64ToBlob(base64, mimeType) {
  const binaryString = atob(base64);
  const length = binaryString.length;
  const bytes = new Uint8Array(length);

  for (let i = 0; i < length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  return new Blob([bytes], { type: mimeType });
}

export function saveOnCdnFiles(
  file,
  filename,
  categoryName,
  file_type = "image",
) {
  const formData = new FormData();
  formData.append("file", file, filename); // Replace "filename.ext" with your desired file name
  formData.append("category", categoryName);
  formData.append("type", "other");
  formData.append("file_type", file_type);

  return new Promise((resolve, reject) => {
    try {
      rbAxios
        .post("/files", formData)
        .then((data) => resolve(data))
        .catch((error) => {
          // this.$toast.error('خطای آپلود تصویر!')
          reject(error);
        });
    } catch (e) {
      reject(e);
    }
  });
}

export function imageToPlainTextAi({ file, description }) {
  const aiApi = Vue.prototype.$aiApi;
  return new Promise((resolve, reject) => {
    const formData = new FormData();
    formData.append("file", file); // Replace "filename.ext" with your desired file name
    formData.append("description", description);

    rbAxios
      .post(aiApi + "/image/generate-description", formData, {
        timeout: 100000,
      })
      .then((data) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
